export default __webpack_public_path__ + "static/media/menu-icon-bullet.b6522ea9.svg";